// Module-level singleton snapshot for the Funding Request dashboard, so the page
// survives route navigation (component state is destroyed on unmount). On
// re-entry the page renders this instantly, then revalidates with a full
// background reload (funding requests mutate, so there is no append-only delta
// like the audit log). One snapshot per SPA session; resets on reload.

let snapshot = null; // { key, state, savedAt }

// View key: "My" (per alias) and "Show All" (per day window) load different
// data, so a different key means the snapshot does not apply and the page
// falls back to a normal load.
export const buildFundingKey = (showAll, daysFilter, alias) =>
  showAll ? `all:${daysFilter ?? ''}` : `mine:${alias ?? ''}`;

// Single snapshot; it carries its own view (showAll/days), so the page restores
// the last active view, not the default.
export const peekFundingSnapshot = () => snapshot;

// state: render-state to restore instantly (loaded list + page/table view).
export const saveFundingSnapshot = (key, state) => {
  snapshot = { key, state, savedAt: Date.now() };
};

export const clearFundingSnapshot = () => {
  snapshot = null;
};
